import ContactForm from './ContactForm';

export default function ContactMapForm() {
  return (
    <section className="py-16 sm:py-20 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Left — Form */}
          <div>
            <ContactForm />
          </div>

          {/* Right — Map + Details */}
          <div className="flex flex-col gap-6">
            {/* Map */}
            <div
              className="relative rounded-2xl overflow-hidden border border-gray-100 shadow-sm"
              style={{ height: '360px' }}
            >
              <iframe
                title="Asili Visuals Office Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.7427186712753!2d32.61245977357689!3d0.3527178639722185!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x177dbbe2eb3d1a27%3A0xba696e96a9228ab8!2sAsili%20Visuals!5e0!3m2!1sen!2sug!4v1771660661765!5m2!1sen!2sug"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen={true}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full h-full"
              ></iframe>
            </div>

            {/* Office Details Card */}
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 sm:p-8">
              <h3 className="text-base font-bold text-[#0D0D0D] mb-5 flex items-center gap-2">
                <div className="w-8 h-8 bg-[#038C7F]/10 rounded-lg flex items-center justify-center">
                  <i className="ri-building-4-line text-[#038C7F] text-sm"></i>
                </div>
                Office Details
              </h3>

              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 bg-[#038C7F]/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-map-pin-2-line text-[#038C7F] text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-gray-700 mb-0.5">Address</p>
                    <p className="text-xs text-gray-500 leading-relaxed">
                      Block B&C 3rd Floor<br />
                      Ntinda Shopping Complex<br />
                      Plot 31 Ntinda - Kisaasi Rd<br />
                      Kampala, Uganda
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 bg-[#F2780C]/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-time-line text-[#F2780C] text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-gray-700 mb-0.5">Business Hours</p>
                    <div className="space-y-1">
                      <div className="flex items-center justify-between gap-6">
                        <span className="text-xs text-gray-500">Monday – Friday</span>
                        <span className="text-xs font-semibold text-[#0D0D0D]">9:00 AM – 6:00 PM</span>
                      </div>
                      <div className="flex items-center justify-between gap-6">
                        <span className="text-xs text-gray-500">Saturday</span>
                        <span className="text-xs font-semibold text-[#0D0D0D]">10:00 AM – 2:00 PM</span>
                      </div>
                      <div className="flex items-center justify-between gap-6">
                        <span className="text-xs text-gray-500">Sunday</span>
                        <span className="text-xs text-gray-400">Closed</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 bg-[#038C7F]/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-earth-line text-[#038C7F] text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-gray-700 mb-0.5">Timezone</p>
                    <p className="text-xs text-gray-500">East Africa Time (EAT) · UTC+3</p>
                  </div>
                </div>
              </div>

              <div className="mt-6 pt-5 border-t border-gray-100">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-3">
                  Serving
                </p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: 'Uganda', flag: '🇺🇬' },
                    { name: 'Kenya', flag: '🇰🇪' },
                    { name: 'Tanzania', flag: '🇹🇿' },
                    { name: 'Rwanda', flag: '🇷🇼' },
                    { name: 'South Sudan', flag: '🇸🇸' },
                  ].map((c) => (
                    <span
                      key={c.name}
                      className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-gray-50 border border-gray-100 rounded-full text-[10px] font-medium text-gray-600"
                    >
                      <span>{c.flag}</span>
                      {c.name}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Quick Connect */}
            <div className="grid grid-cols-2 gap-3">
              <a
                href="mailto:info@asili.co.ug"
                className="group flex items-center gap-3 bg-white rounded-xl border border-gray-100 shadow-sm p-4 hover:shadow-md hover:border-[#038C7F]/30 transition-all cursor-pointer"
              >
                <div className="w-10 h-10 bg-[#038C7F]/10 rounded-lg flex items-center justify-center group-hover:bg-[#038C7F] transition-colors">
                  <i className="ri-mail-line text-[#038C7F] group-hover:text-white transition-colors text-lg"></i>
                </div>
                <div>
                  <p className="text-xs font-bold text-[#0D0D0D]">Email</p>
                  <p className="text-[10px] text-gray-400">info@asili.co.ug</p>
                </div>
              </a>
              <a
                href="tel:+256761375736"
                className="group flex items-center gap-3 bg-white rounded-xl border border-gray-100 shadow-sm p-4 hover:shadow-md hover:border-[#F2780C]/30 transition-all cursor-pointer"
              >
                <div className="w-10 h-10 bg-[#F2780C]/10 rounded-lg flex items-center justify-center group-hover:bg-[#F2780C] transition-colors">
                  <i className="ri-phone-line text-[#F2780C] group-hover:text-white transition-colors text-lg"></i>
                </div>
                <div>
                  <p className="text-xs font-bold text-[#0D0D0D]">Phone</p>
                  <p className="text-[10px] text-gray-400">0761 375736</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
